<div class="modal-window">
    <h3>{{downloadTypeString}} output(s)</h3>
    <form class="standard-form modal-content" [formGroup]="strategyMapDownloadForm">
        <h4>Select the output(s) to {{downloadTypeString | lowercase}}</h4>

        <div class="form-row">
          <div class="checkbox checkbox-branded">
            <input #allCheckbox type="checkbox" id="selectAll" formControlName="allCheckbox"
               (change)="onSelectAllChange()"/>
            <label for="selectAll"></label>
          </div>
          <span class="option-label" [ngClass]="{'label-selected': allCheckbox.checked }">Select all</span>
        </div>

        <div class="form-row">
          <div class="checkbox checkbox-branded">
            <input #strategyMapCheckbox type="checkbox" id="strategyMapCheckbox" formControlName="strategyMapCheckbox"
            (change)="onOutputsCheckboxChange(strategyMapCheckbox.checked, ['priorityCount'])"/>
            <label for="strategyMapCheckbox"></label>
          </div>
          <span class="option-label" [ngClass]="{'label-selected': strategyMapCheckbox.checked }">Strategy Map</span>
          <div class="control-container">
            <p-dropdown class="app-form-dropdown strategy-map-dropdown" [autoWidth]="false"
             formControlName="priorityCount"></p-dropdown>
          </div>
        </div>

        <div class="form-row">
          <div class="checkbox checkbox-branded">
            <input #annualPlansCheckbox type="checkbox" id="annualPlansCheckbox" formControlName="annualPlansCheckbox"
            (change)="onOutputsCheckboxChange(annualPlansCheckbox.checked, ['annualEndDate', 'annualStartDate'])"/>
            <label for="annualPlansCheckbox"></label>
          </div>
          <span class="option-label" [ngClass]="{'label-selected': annualPlansCheckbox.checked }">Annual Improvement Plan(s)</span>
          <div class="control-container">
            <p-calendar styleClass="strategies-calendar strategy-map-calendar" [maxDate]="annualEndDate.value"
             inputStyleClass="standard-input" formControlName="annualStartDate" placeholder="Start Date"
                        [showIcon]="true">
            </p-calendar>
            <p-calendar styleClass="strategies-calendar strategy-map-calendar" [minDate]="annualStartDate.value"
              inputStyleClass="standard-input" formControlName="annualEndDate" placeholder="End Date" [showIcon]="true">
            </p-calendar>
          </div>
        </div>

        <div class="form-row">
          <div class="checkbox checkbox-branded">
            <input #implCheckbox type="checkbox" id="implCheckbox" formControlName="implCheckbox"
             (change)="onOutputsCheckboxChange(implCheckbox.checked, ['implEndDate', 'implStartDate'])"/>
            <label for="implCheckbox"></label>
          </div>
          <span class="option-label" [ngClass]="{'label-selected': implCheckbox.checked }">Annual Implementation Plan(s)</span>
          <div class="control-container">
            <p-calendar styleClass="strategies-calendar strategy-map-calendar" [maxDate]="implEndDate.value"
             inputStyleClass="standard-input" formControlName="implStartDate" placeholder="Start Date"
                        [showIcon]="true">
            </p-calendar>
            <p-calendar styleClass="strategies-calendar strategy-map-calendar" [minDate]="implStartDate.value"
             inputStyleClass="standard-input" formControlName="implEndDate" placeholder="End Date" [showIcon]="true">
            </p-calendar>
          </div>
        </div>

        <div class="form-row">
          <div class="checkbox checkbox-branded">
            <input #theoryOfActionsCheckbox type="checkbox" id="theoryOfActions"
                   formControlName="theoryOfActionsCheckbox"
                   (change)=
                     "onOutputsCheckboxChange(theoryOfActionsCheckbox.checked, ['theoryOfActionsMultiSelect'])"/>
            <label for="theoryOfActions"></label>
          </div>
          <span class="option-label"
                [ngClass]="{'label-selected': theoryOfActionsCheckbox.checked }">Theory of Action</span>
          <div class="control-container">
            <p-multiSelect [options]="initiativeTemplateItems" [maxSelectedLabels]="1"
                           defaultLabel="Select Critical Initiative(s)" scrollHeight="150px"
             [filter]="false" styleClass="strategies-multiselect" formControlName="theoryOfActionsMultiSelect"
                           [panelStyle]="{width:'600px'}"
             selectedItemsLabel="{0} Critical Initiatives selected" (onChange)="onDropDownChange($event)">
              <ng-template let-initiative let-i="index" pTemplate="item">
                <!-- if the initiative has a value show the standard template -->
                <div *ngIf="initiative.value" [style.borderLeftColor]="initiative.value.colorCode"
                     class="select-item-template-token">
                  <div class="select-item-template-text">
                    <strong>{{ initiative.value.title }}</strong> {{ initiative.value.text }}
                     <ng-container *ngIf="initiative.label.length > initiative.value.INITIATIVE_DESCRIPTION_MAX_LENGTH">
                        (<a [pTooltip]="initiative.label" tooltipStyleClass="dropdown-tooltip">...</a>)
                     </ng-container>
                  </div>
                </div>
                <!-- if the initiative has no value, show the select all option-->
                <div #selectAll *ngIf="!initiative.value" class="select-item-template-token select-all"
                     (click)="selectAllItemsClick($event)">
                    <div class="select-item-template-text">
                        Select All
                    </div>
                </div>
              </ng-template>
            </p-multiSelect>
          </div>
        </div>

        <hr class="form-seperator">
        <h4>Select one or more formats</h4>

        <div class="form-row">
          <div class="checkbox checkbox-branded">
            <input #pdfDoc type="checkbox" id="pdfDoc" formControlName="pdfDoc"/>
            <label for="pdfDoc"></label>
          </div>
          <span class="option-label" [ngClass]="{'label-selected': pdfDoc.checked }">PDF</span>
          <div class="checkbox checkbox-branded">
            <input #wordDoc type="checkbox" id="wordDoc" formControlName="wordDoc"/>
            <label for="wordDoc"></label>
          </div>
          <span class="option-label" [ngClass]="{'label-selected': wordDoc.checked }">Word</span>
        </div>

        <div class="button-error-row">
          <div class="error-cell">
            <div *ngIf="noOutputsSelected()">No output selected for {{ downloadTypeString }}.</div>
            <div *ngIf="annualPlanDatesInvalid()">Annual Improvement Plan(s) - Start Date must be earlier than End Date.</div>
            <div *ngIf="noAnnualPlanStartDate()">Annual Improvement Plan(s) - No Start Date selected.</div>
            <div *ngIf="implDatesInvalid()">Annual Implementation Plan(s) - Start Date must be earlier than End Date.</div>
            <div *ngIf="noImplStartDate()">Annual Implementation Plan(s) - No Start Date selected.</div>
            <div *ngIf="noIntiativeSelected()">Theory Of Action - No Critical Initiative selected.</div>
            <div *ngIf="noDocTypeSelected()">No format selected.</div>
          </div>
          <div class="button-cell">
            <input type="button" class="btn btn-alt left-btn btn-strategy-map" (click)="onHideModalClick()"
                   value="Cancel"/>
            <input type="button" class="btn btn-strategy-map smd-btn" (click)="onClickDownloadButton()"
                   formControlName="submitButton" value="Download">
          </div>
        </div>
    </form>
  </div>
